





































































































































import Component from 'vue-class-component';
import { EditPage } from '@/components/base/edit/edit-page';
import * as ent from '@/entities';
import siteTypesApi from '@/api/site-types.api';
import sitesApi from '@/api/sites.api';


@Component({})
export default class SiteTypesEdit extends EditPage {
    public useApproveSale : boolean = false;


    get siteId(): number {
        return Number.parseInt(this.$route.params.siteId, 10);
    }

    get parentPath(): string {
        return `/app/sites/${this.siteId}/types`;
    }

    public formState: ent.IDictionary<ent.IFormControl> = {
        typename: {
            key: 'typename',
            label: `Link Name`,
            value: '',
            validators: 'required'
        },
        typealias: {
            key: 'typealias',
            label: 'Link Alias',
            value: '',
            validators: 'required'
        },
        bbrCh: {
            key: 'bbrCh',
            label: 'Integration channel',
            value: '',
            validators: ''
        },
        username: {
            key: 'username',
            label: 'Username',
            value: '',
            validators: 'required'
        },
        url: {
            key: 'url',
            label: 'Link URL',
            value: '',
            validators: 'required|url'
        },
        payout: {
            key: 'payout',
            label: 'Payout (₱)',
            value: 0,
            validators: 'required|decimal|min_value:0'
        },
        earning: {
            key: 'earning',
            label: 'Earning ($)',
            value: 0,
            validators: 'required|decimal|min_value:0'
        },
        lpp: {
            key: 'lpp',
            label: 'lpp',
            value: 1,
            validators: 'required|integer|min_value:0'
        },
        bonusPayout: {
            key: 'bonusPayout',
            label: 'Bonus Payout (₱)',
            value: 0,
            validators: 'decimal|min_value:0'
        },
        bonusEarning: {
            key: 'bonusEarning',
            label: 'Bonus Earning ($)',
            value: 0,
            validators: 'decimal|min_value:0'
        },
        bonusLpp: {
            key: 'bonusLpp',
            label: 'Bonus lpp',
            value: 1,
            validators: 'integer|min_value:0'
        },
        active: {
            key: 'active',
            label: 'Activated',
            value: false
        },
        bonus: {
            key: 'bonus',
            label: 'Bonus',
            value: false
        },
        status: {
            key: 'activated',
            label: 'Activated',
            value: ent.SiteStatus.Suspended
        }
    };

    public async created() {
        const site = await sitesApi.get(this.siteId);
        this.useApproveSale = site.useApproveSale;
        this.updateFormStateLabels(this.useApproveSale);
        await super.created();

        if (this.isNew) {
            this.formState.status.value = ent.SiteStatus.Activated;
        }
    }

    // TODO own resourse service will be nice for api calls
    public detail(id: number): Promise<ent.ISiteTypeDetailModel> {
        return siteTypesApi.get(id);
    }

    public create(body: any): Promise<number> {
        return siteTypesApi.create({ ...body, siteId: this.siteId });
    }

    public update(body: any): Promise<number> {
        return siteTypesApi.update(this.id, body);
    }

    private updateFormStateLabels(useApproveSale){
        this.formState.bonus.label = !useApproveSale ? 'Bonus' : 'Day#2 Sale';
        this.formState.bonusPayout.label = !useApproveSale ? 'Bonus Payout (₱)' : 'Day#2 Payout (₱)';
        this.formState.bonusEarning.label = !useApproveSale ? 'Bonus Earning ($)' : 'Day#2 Earning ($)';
        this.formState.bonusLpp.label = !useApproveSale ? 'Bonus lpp' : 'Day#2 lpp';
    }
}
